import React from "react";
import styles from "./OverviewFailureTable.module.scss";

const OverviewFailureTable = ({ data }: any) => {
  return (
    <div className={styles.wrapper}>
      {data?.map((err: any, i: number) => (
        <div key={`jdh${i}`} className={styles.itemWrapper}>
          <div className={styles.indexWrapper}>
            <span>{i + 1}</span>
            <p>{err?.responsemessage}</p>
          </div>
          <p>{err?.count ?? "N/A"}</p>
        </div>
      ))}
    </div>
  );
};

export default OverviewFailureTable;
